/**
 * Apollo Client Configuration
 * Connects to the Slope GraphQL API
 */

import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

// Get the API URL from environment variable
const API_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001';

// Create the HTTP link to the GraphQL endpoint
const httpLink = createHttpLink({
  uri: `${API_URL}/graphql/v1`,
  credentials: 'include', // Include cookies for session authentication
});

// Add session ID header to every request
const authLink = setContext((_, { headers }) => {
  // Get session ID from localStorage
  const sessionId = localStorage.getItem('sessionId');
  
  return {
    headers: {
      ...headers,
      ...(sessionId ? { 'x-session-id': sessionId } : {}),
    },
  };
});

// Create the Apollo Client instance
export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          // Define cache behavior for organizations query
          organizations: {
            merge(_existing = [], incoming) {
              return incoming;
            },
          },
        },
      },
      Organization: {
        keyFields: ['id'],
      },
      Contact: {
        keyFields: ['id'],
      },
      Address: {
        keyFields: ['id'],
      },
    },
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
});
